import React from 'react';

export const RarityMarker = ({ value }) => (
    <div className={`dm-rarity-marker dm-rarity-marker--${value}`} />
);
